<div class="white-box profile-2fa-wrapper" [ngSwitch]="currentScreen">
  <!-- Main -->
  <div *ngSwitchDefault>
    <h3 class="ui-headline">{{ '2fa.title' | translate }}</h3>
    <p *ngIf="enabled2FA">{{ '2fa.enabled.p1' | translate }}</p>
    <p *ngIf="!enabled2FA">
      {{ '2fa.disabled.p' | translate }}
      <a [href]="getArticle()" target="_blank"> {{ 'learn_more' | translate }} </a>.
    </p>
    <div class="toggle-box">
      <p>{{ '2fa.disabled.toggle.label' | translate }}</p>
      <app-ui-button-toggle [checked]="enabled2FA" (changeEventDispatch)="toggle2FA()"></app-ui-button-toggle>
    </div>
    <p *ngIf="enabled2FA">{{ '2fa.enabled.p2' | translate: { phoneNumber: customer.verified_phone || customer.unverified_phone } }}</p>
  </div>
  <!-- Password -->
  <app-profile-password
    *ngSwitchCase="'password'"
    [customer]="customer"
    [enabled2FA]="enabled2FA"
    [loading]="loading"
    (validatePassword)="validatePassword($event)"
  ></app-profile-password>
  <!-- Phone -->
  <app-profile-2fa-phone
    *ngSwitchCase="'phone'"
    [customer]="customer"
    [enabled2FA]="enabled2FA"
    [loading]="loading"
    [token]="token"
  ></app-profile-2fa-phone>
  <!-- Verify code -->
  <app-profile-verify
    *ngSwitchCase="'verify'"
    [phoneNumber]="customer.verified_phone || customer.unverified_phone"
    [enabled2FA]="enabled2FA"
    [loading]="loading"
    (resendSMSCode)="resendSMSCode()"
    (validateCode)="validateCode($event)"
  ></app-profile-verify>
  <!-- Help -->
  <app-profile-2fa-help *ngSwitchCase="'help'"></app-profile-2fa-help>
</div>

<app-profile-dialog-2fa-disable
  *ngIf="openDisable2FA"
  (confimed)="toggle2FA()"
  (closed)="openDisable2FA = !$event; enabled2FA = true"
></app-profile-dialog-2fa-disable>
